module.exports = __webpack_public_path__ + "img/masked_nutrucionista.27c66b04.svg";